const AvailableLesson = (state = {lessons:[],branch:""} , action) => {
    switch(action.type){
        case  'updateAvailableLesson':
            return  action.payload;
        default :
            return state;
    }
}
export default AvailableLesson;